'use client';

import { useState, useEffect } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface SearchBarProps {
  onSearch: (filters: SearchFilters) => void;
  availableCategories: string[];
  availableSources: string[];
}

export interface SearchFilters {
  keyword: string;
  dateFrom: string;
  dateTo: string;
  category: string;
  source: string;
}

export default function SearchBar({ onSearch, availableCategories, availableSources }: SearchBarProps) {
  const [keyword, setKeyword] = useState('');
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearch = () => {
    onSearch({
      keyword: keyword.trim(),
      dateFrom: '',
      dateTo: '',
      category: 'all',
      source: 'all'
    });
  };

  if (!isHydrated) {
    return (
      <div className="w-full bg-white rounded-lg shadow-sm border border-gray-200 p-4">
        <div className="flex gap-2">
          <div className="flex-1 h-10 bg-gray-100 rounded animate-pulse"></div>
          <div className="w-10 h-10 bg-gray-100 rounded animate-pulse"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      {/* Simple Search Bar */}
      <div className="flex gap-2 items-center">
        <div className="flex-1 relative">
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            placeholder="Search articles by keyword..."
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <button
          onClick={handleSearch}
          className="px-2 py-1 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs font-medium rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-1"
        >
          <MagnifyingGlassIcon className="w-3 h-3" />
          Search
        </button>
      </div>
    </div>
  );
}